import { createRouter, createWebHistory } from 'vue-router'
// import liff from '@line/liff'
// import { reactive } from 'vue'

import { useLiffStore } from '@/store/liff'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/dalmore',
    },
    {
      path: '/:brand(dalmore|jura|fettercairn|tamnavulin)',
      children: [
        {
          path: '',
          name: 'Member',
          component: () => import('../views/Member/Index.vue'),
          meta: {
            shareBtn: true,
          },
        },
        {
          path: 'positive-drinking',
          children: [
            {
              path: '',
              name: 'Agreement',
              component: () => import('../views/Agreement/Index.vue'),
            },
            {
              path: 'result',
              name: 'AgreementResult',
              component: () => import('../views/Agreement/Result.vue'),
            },
          ],
        },
        {
          path: 'event/:id',
          children: [
            {
              path: '',
              name: 'Event',
              component: () => import('../views/Event/Index.vue'),
              meta: {
                login: false,
                shareBtn: true,
              },
            },
            {
              path: 'detail',
              name: 'EventDetail',
              component: () => import('../views/Event/Detail.vue'),
              meta: {
                shareBtn: true,
              },
            },
            {
              path: 'share',
              name: 'EventShare',
              component: () => import('../views/Event/Share.vue'),
              meta: {
                shareBtn: true,
              },
            },
          ],
        },
        {
          path: 'event/ticket',
          children: [
            {
              path: '',
              name: 'Ticket',
              component: () => import('../views/Event/Ticket/Index.vue'),
            },
            {
              path: ':id',
              name: 'TicketDetail',
              component: () => import('../views/Event/Ticket/Detail.vue'),
            },
          ],
        },
      ],
    },

    //以下為舊頁面全部進行轉到到 dalmore 底下
    {
      path: '/positive-drinking',
      redirect: {
        name: 'Agreement',
        params: {
          brand: 'dalmore',
        },
      },
    },
    {
      path: '/event/:id',
      meta: {
        login: false,
        shareBtn: true,
      },
      redirect: (to) => ({
        name: 'Event',
        params: {
          ...to.params,
          brand: 'dalmore',
        },
      }),
    },
    {
      path: '/event/detail/:id',
      redirect: (to) => ({
        name: 'EventDetail',
        params: {
          ...to.params,
          brand: 'dalmore',
        },
      }),
    },
    {
      path: '/event/share/:id',
      redirect: (to) => ({
        name: 'EventShare',
        params: {
          ...to.params,
          brand: 'dalmore',
        },
      }),
    },
    {
      path: '/event/ticket',
      redirect: (to) => ({
        name: 'Ticket',
        params: {
          ...to.params,
          brand: 'dalmore',
        },
      }),
    },
    {
      path: '/event/ticket/:id',
      redirect: (to) => ({
        name: 'TicketDetail',
        params: {
          ...to.params,
          brand: 'dalmore',
        },
      }),
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: {
        name: 'dalmore',
      },
    },
  ],
})

if (process.env.VUE_APP_MODE !== 'build') {
  router.addRoute({
    path: '/:brand(dalmore)/delete',
    name: 'Delete',
    component: () => import('../views/Member/Delete.vue'),
  })
}

router.beforeEach(async (to) => {
  const liffStore = useLiffStore()

  await liffStore.liffinit()

  if (to.meta?.login !== false) {
    await liffStore.liffLogin()
  }

  return true
})

export default router
